import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    n: 1, title: "Data yang Kami Kumpulkan",
    blocks: [
      { sub: "Data Akun", ul_items: ["Nama", "Alamat email", "Kata sandi (disimpan dalam bentuk terenkripsi)"] },
      { sub: "Data Profil Kreator", ul_items: ["Nama profil/channel", "Platform utama (YouTube, TikTok, Instagram, X)", "Niche/topik konten", "Target audiens", "Gaya bicara", "Tujuan konten", "Hal-hal yang menurut Anda membuat konten Anda berbeda"] },
      { sub: "Data Penggunaan", ul_items: ["Riwayat percakapan di fitur Brainstorming", "Script dan draft konten yang dihasilkan lewat fitur Susun Script, Recreate Konten, dan Peta Konversi", "Jadwal konten yang Anda susun di Kalender Konten", "File audio/video yang Anda unggah untuk fitur Recreate Konten (untuk keperluan transkripsi)"] },
      { sub: "Data Transaksi", ul_items: ["Riwayat langganan (paket, tanggal mulai, tanggal berakhir, status pembayaran)", "Kami tidak menyimpan data kartu, rekening bank, atau detail pembayaran Anda secara langsung"] },
    ],
  },
  {
    n: 2, title: "Bagaimana Kami Menggunakan Data Anda",
    blocks: [
      { p: "Kami menggunakan data yang Anda berikan untuk:" },
      { ul: [
        "Mempersonalisasi hasil dari fitur-fitur AI (script, ide konten, rekomendasi funnel) agar sesuai dengan gaya dan brand Anda",
        "Memproses dan mengelola langganan Anda",
        "Memberikan dukungan pelanggan",
        "Meningkatkan kualitas layanan kami secara umum",
      ] },
      { p: "Kami **tidak menjual** data pribadi Anda kepada pihak ketiga mana pun." },
    ],
  },
  {
    n: 3, title: "Pihak Ketiga yang Terlibat",
    blocks: [
      { p: "Kami bekerja sama dengan penyedia layanan berikut untuk mengoperasikan Studio Kreator:" },
      { ul: [
        "**Paywuz** — memproses pembayaran langganan Anda (QRIS/Virtual Account). Data yang dibagikan ke Paywuz terbatas pada informasi yang diperlukan untuk memproses transaksi (jumlah pembayaran, ID pesanan).",
        "**Penyedia layanan AI** — digunakan untuk menghasilkan konten (script, ide, rekomendasi) berdasarkan input yang Anda berikan.",
      ] },
      { p: "Kami memastikan mitra-mitra ini memiliki standar keamanan dan privasi yang memadai dalam menangani data Anda." },
    ],
  },
  {
    n: 4, title: "Penyimpanan dan Keamanan Data",
    blocks: [
      { p: "Data Anda disimpan selama akun Anda aktif, dan akan dihapus dalam jangka waktu tertentu setelah Anda menghapus akun (kecuali data yang wajib disimpan untuk keperluan hukum/pajak, seperti riwayat transaksi)." },
      { p: "Kami menerapkan langkah keamanan standar industri untuk melindungi data Anda, termasuk enkripsi data sensitif dan pembatasan akses internal. Meski begitu, tidak ada sistem yang 100% aman — kami mendorong Anda untuk menjaga kerahasiaan kata sandi akun Anda." },
    ],
  },
  {
    n: 5, title: "Hak Anda",
    blocks: [
      { p: "Sebagai pengguna, Anda berhak untuk:" },
      { ul: [
        "Mengakses data pribadi yang kami simpan tentang Anda",
        "Meminta koreksi atas data yang tidak akurat",
        "Meminta penghapusan akun dan data terkait (dengan pengecualian data yang wajib disimpan untuk keperluan hukum)",
        "Berhenti berlangganan kapan saja melalui halaman Kelola Langganan",
      ] },
      { p: "Untuk menggunakan hak-hak ini, hubungi kami melalui email di bawah." },
    ],
  },
  {
    n: 6, title: "Cookie dan Teknologi Pelacakan",
    blocks: [{ p: "Kami dapat menggunakan cookie atau teknologi serupa untuk keperluan analitik dasar (misalnya memahami bagaimana pengguna berinteraksi dengan landing page kami) guna meningkatkan pengalaman pengguna." }],
  },
  {
    n: 7, title: "Perubahan Kebijakan",
    blocks: [{ p: "Kami dapat memperbarui kebijakan ini dari waktu ke waktu. Perubahan signifikan akan diinformasikan melalui email atau pemberitahuan di dalam aplikasi." }],
  },
  {
    n: 8, title: "Kontak",
    blocks: [
      { p: "Jika Anda memiliki pertanyaan seputar kebijakan privasi ini atau ingin menggunakan hak Anda atas data pribadi, silakan hubungi kami di:" },
      { p: "**Email:** halo@studiokreator.id" },
    ],
  },
];

export default function KebijakanPrivasi() {
  return <LegalLayout title="Kebijakan Privasi" lastUpdated="1 September 2026" sections={SECTIONS} />;
}
